module.exports = __webpack_public_path__ + "static/img/07.d1b1f004.png";